import script from "./MWReportInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MWReportInfo.vue?vue&type=script&lang=ts&setup=true"

import "./MWReportInfo.vue?vue&type=style&index=0&id=96faa870&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96faa870"]])

export default __exports__